import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { Button } from '@mui/material';
import { fetchRelatedRecords, useDataProvider, useNotify, useListContext, useResourceContext, useTranslate } from 'react-admin';
import ExportIcon from '@/assets/icons/export-icon.svg?react';

const CustomExportButton = ({ label, onClose, maxResults = 1000 }) => {
    const translate = useTranslate();
    const buttonLabel = label || translate('common.export');
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const { filter, filterValues, sort, exporter, total } = useListContext();
    const resource = useResourceContext();

    const handleClick = useCallback(() => {
        if (onClose) {
            onClose();
        }

        dataProvider
            .getList(resource, {
                sort,
                filter: filter ? { ...filterValues, ...filter } : filterValues,
                pagination: { page: 1, perPage: maxResults },
            })
            .then(({ data }) => exporter?.(data, fetchRelatedRecords(dataProvider), dataProvider, resource))
            .catch(error => {
                console.error(error);
                notify('ra.notification.http_error', { type: 'error' });
            });
    }, [dataProvider, exporter, filter, filterValues, maxResults, notify, onClose, resource, sort]);

    return (
        <Button onClick={handleClick} className='white' disabled={total === 0} aria-label={buttonLabel}>
            <ExportIcon />
            {buttonLabel}
        </Button>
    );
};

CustomExportButton.propTypes = {
    label: PropTypes.string,
    onClose: PropTypes.func,
    maxResults: PropTypes.number,
};

export default CustomExportButton;
